import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { SessionService } from "../shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuardService {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  /**
   * Determines whether the route can be activated.
   * @return True if the route can be activated, or a UrlTree to redirect to otherwise
   */
  canActivate(): boolean | UrlTree {
    return this.checkNotLogin();
  }

  /**
   * Checks that no user is currently logged in.
   * @return True if no user is logged in, or a UrlTree redirecting to /landing otherwise
   */
  checkNotLogin(): boolean | UrlTree {
    if (!this.sessionService.isLoggedIn) {
      return true;
    } else {
      return this.router.createUrlTree(["/landing"]);
    }
  }
}

export const LoginGuard: CanActivateFn = (): boolean | UrlTree => {
  return inject(LoginGuardService).canActivate();
};
